// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PzHo","buttons":"styles_buttons__1YUJC"};